import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import AuctionDetailsItem from '../../common/components/Auction/AuctionDetailsItem';
import { getAuction } from '../../myvehicles/MyVehiclesActions';
import { auctionListType } from '../../constants/AuctionListType';
import { SSE_BUYER, SSEClient } from '../../api/SSEClient';
import { AuctionListTemplateContextType } from '../../common/components/new/AuctionListTemplate';

function MyBidsDetailsPage() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [item, setItem] = useState(null);
  const [auctionTimeStamp, setAuctionTimestamp] = useState(null);

  const navContentRef = useRef();
  const sseClient = new SSEClient(SSE_BUYER);

  useEffect(() => {
    setItem(null);
    setAuctionTimestamp(new Date());
    if (!id || id === 'undefined' || id === 'null') return;
    dispatch(
      getAuction(id, (auction) => {
        if (String(auction?.id) === String(id)) {
          setItem(auction);
        }
      }),
    );
  }, [dispatch, id]);

  const handleGetAuction = (auction) => {
    setAuctionTimestamp(new Date());
    if (auction) {
      setItem(auction);
    } else {
      dispatch(
        getAuction(id, (auction) => {
          setItem(auction);
        }),
      );
    }
  };

  return (
    item && (
      <AuctionDetailsItem
        item={item}
        listType={auctionListType.MY_BIDS}
        sseClient={sseClient}
        refreshItem={handleGetAuction}
        typeSseClient={SSE_BUYER}
        auctionTimestamp={auctionTimeStamp}
        navContentRef={navContentRef}
        inWrapper={true}
        context={AuctionListTemplateContextType.BUYING}
      />
    )
  );
}

export default MyBidsDetailsPage;
